var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Renderer2 } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { AuthenticationStatus } from '../enums/enums';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';
import { ServerResponse } from '../constants/server-response.model';
var AuthCreditCardComponent = /** @class */ (function (_super) {
    __extends(AuthCreditCardComponent, _super);
    function AuthCreditCardComponent(renderer, modalService, authService) {
        var _this = _super.call(this, modalService, authService) || this;
        _this.renderer = renderer;
        _this.modalService = modalService;
        _this.authService = authService;
        _this.date = { day: '', month: '', year: '' };
        _this.data = {};
        return _this;
    }
    AuthCreditCardComponent.prototype.elasticLogit = function () {
        this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2165' })
            .subscribe(function (res) { return console.log("sent elasticLog code:2165 - open window", res); }, function (error) { return console.log("sent elasticLog - open window error!", error); });
    };
    AuthCreditCardComponent.prototype.ngOnInit = function () {
        this.elasticLogit();
        sessionStorage.setItem("currentWindow", "אימות פרטי כרטיס אשראי");
        sessionStorage.setItem("elasticCode", "2192");
        this.data = this.modalService.data;
        this.isShowContactLink = this.shouldContactLink('authCreditCard');
        var element = this.renderer.selectRootElement('#cardnumber');
        setTimeout(function () { return element.focus(); }, 0);
    };
    AuthCreditCardComponent.prototype.submit = function (form) {
        var _this = this;
        var element = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; }).find(function (elm) { return elm.classList.contains('ng-invalid'); });
        if (element) {
            element.setAttribute('aria-invalid', true);
            setTimeout(function () { return element.focus(); }, 0);
        }
        form.value.cardnumber.replace(' ', '');
        if (form.valid && this.isValidDate) {
            this.pending = true;
            this.serverError = null;
            var card = {
                creditCardDetails: {
                    CardNum: form.value.cardnumber.trim(),
                    Month: form.value.month,
                    Year: form.value.year,
                    CVV: form.value.cvv
                }
            };
            //console.log("sent parametes", card);
            this.authUserService.sendAuthData("ValidateCreditCard", card)
                .subscribe(function (res) {
                if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidCreditCard") {
                    _this.elasticLogit();
                    _this.serverError = "פרטי כרטיס האשראי שהקלדת אינם תקינים או אינם תואמים את פרטיך. יש להזין פרטי כרטיס הרשום על שמך ולוודא שהם תואמים את הכתוב על הכרטיס.";
                }
                else if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidCreditCardTech") {
                    _this.elasticLogit();
                    _this.serverError = "אירעה תקלה באימות פרטי כרטיס האשראי שלך. אנו מטפלים בתקלה. יש לנסות שוב במועד מאוחר יותר.";
                }
                else {
                    if (res.Status == AuthenticationStatus.Success && res.Details.ProcessSuccess != ServerResponse.NEED_DETAILS) {
                        res.Details.ProcessSuccess = ServerResponse.ISSUE_DATE;
                    }
                    _this.modalService.close(res.Details);
                }
            }, function () { return _this.pending = false; }, function () { return _this.pending = false; });
        }
        this.buildFormAccessibility();
    };
    AuthCreditCardComponent.prototype.validateDate = function () {
        this.isValidDate = new Date().getMonth() + 1 <= parseInt(this.date.month) &&
            new Date().getFullYear() == parseInt("20" + this.date.year) || new Date().getFullYear() < parseInt("20" + this.date.year);
    };
    return AuthCreditCardComponent;
}(AuthBaseComponent));
export { AuthCreditCardComponent };
